var map = {
	"./background_registration.png": "d43e",
	"./gif/Analytics.png": "07a5",
	"./gif/Brandkit.png": "4e10",
	"./gif/Cloud Sync.png": "17cc",
	"./gif/Collections.png": "3f2a",
	"./gif/Flow Chart.png": "e9ca",
	"./gif/Social Media Publishing.png": "9915",
	"./gif/Template.png": "47bc",
	"./logo.png": "cf05",
	"./marker.png": "3b84",
	"./mastercard.png": "7e5a",
	"./rights_text.png": "b7b9",
	"./visa.png": "4b12",
	"./welcome_bg.png": "d321"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";